import {
  Alert,
  AlertTitle,
  Button,
  Card,
  CardContent,
  CircularProgress,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes as actionNotifycation } from "redux/notificationAlert/index";
import { insert_pod_paya_payment } from "redux/payments/insert_pod_paya_payment";
import { actionTypes as financialActionType } from "redux/payments/select_financial_sejam_profile";
import { actionTypes as balanceDataActiontype } from "redux/payments/select_withdrawal_balance";
import { actionTypes } from "redux/select_financial_status/indx";
import { useHistory } from "react-router-dom";
import { Info } from "@mui/icons-material";

let useStyles = makeStyles((theme) => ({
  modal: {
    width: "100%",
    backgroundColor: "white",
    padding: 20,
    minHeight: "80vh",
    marginTop: 20,
  },
  modal_alert: {
    display: "flex",
    minHeight: 200,
    backgroundColor: "#ffffff",
    zIndex: 100,
    borderRadius: 5,

    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-45%, -50%)",
    bgcolor: "background.paper",
    outline: 0,
    border: 0,
    boxShadow: 24,
    maxHeight: "500px",
    overflow: "auto",
  },
  ul: {
    listStyleType: "lower-alpha",
  },
}));

const WithdrawalCard = () => {
  let classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [amount, setAmount] = useState("100,000");
  const [maxAmount, setMaxAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [bankMessage, setBankMessage] = useState("");
  const [isCheckedRules, setIsCheckedRules] = useState(false);
  const removeSeparator = (value) => {
    return value?.replace(/,/g, "");
  };
  const history = useHistory();

  const handleRedirect = () => {
    history.push("/bank-accounts");
  };
  const dispatch = useDispatch();
  const stateData = useSelector(
    (state) => state.select_financial_status_Reducer,
  );
  const balanceData = useSelector(
    (state) => state.selectWithdrawalBalanceReducer,
  );
  const financialReducer = useSelector(
    (state) => state.selectFinancialSejamProfileReducer,
  );
  const financialData = financialReducer?.data?.body;

  useEffect(() => {
    if (financialData?.psg.length) {
      setAccounts(financialData?.psg || []);
    }
    if (financialData?.banks.length) {
      setBanks(financialData.banks || []);
    }
  }, [financialData]);

  useEffect(() => {
    dispatch({
      type: actionTypes.selectFinancialStatusAsync,
      payload: { data: {} },
    });
    dispatch({
      type: financialActionType.selectFinancialSejamProfileAsync,
      payload: { data: {} },
    });
    dispatch({
      type: balanceDataActiontype.selectWithdrawalBalanceAsync,
      payload: { data: {} },
    });
  }, [dispatch]);
  const balance = balanceData?.data?.body?.withdrawal_balance;

  const data = stateData?.data?.[0]?.body;

  useEffect(() => {
    if (data?.AdjustedRemain && data?.CurrentRemain) {
      setMaxAmount(balance);
    }
  }, [data?.AdjustedRemain, data?.CurrentRemain, balance]);

  const withdraw = () => {
    if (removeSeparator(amount) > maxAmount) {
      return dispatch({
        type: actionNotifycation.warning,
        textAlert:
          "مشتری گرامی مبلغ درخواستی شما باید کمتر یا مساوی مبلغ حداکثر قابل برداشت باشد.",
      });
    }

    if (selectedOption.bank_name.includes("آینده")) {
      return dispatch({
        type: actionNotifycation.warning,
        textAlert:
          "مشتری گرامی سرویس برداشت آنی برای بانک آینده هم اکنون در دسترس نمی باشد.",
      });
    }

    //     if (
    //   selectedOption.bank_name.includes("تجارت") ||
    //   selectedOption.bank_name.includes("ملی") ||
    //   selectedOption.bank_name.includes("صادرات") ||
    //   selectedOption.bank_name.includes("توسعه صادرات")
    // ) {
    //   return dispatch({
    //     type: actionNotifycation.warning,
    //     textAlert:
    //       "کاربر گرامی متاسفانه به دلیل اختلالات بانکی تراکنش بانک های تجارت ، ملی ، صادرات و توسعه صادرات با اختلال رو به رو هستند .",
    //   });
    // }

    setLoading(true);

    const apiCall = insert_pod_paya_payment({
      customer_bank_account_id: selectedOption.sheba_number,
      request_amount: Number(removeSeparator(amount)),
      bank_name: selectedOption.bank_name,
    });

    apiCall
      .then((res) => {
        if (res.data.response.is_successful) {
          dispatch({
            type: actionNotifycation.success,
            textAlert: "درخواست شما با موفقیت ثبت شد.",
          });
          setSelectedOption("");
        } else {
          handleNotificationAlertTrySelect(res);
        }
      })
      .catch(() => handleNotificationAlertCatch())
      .finally(() => {
        setLoading(false);
        // setOpenModal(false);
      });
  };

  const formatSeperatorValue = (value) => {
    if (!value || value === "null" || value === undefined) {
      setAmount("");
      return;
    }

    const rawValue = String(value).replace(/[^0-9.]/g, "");
    const fixedValue = Number(rawValue).toFixed(0);
    const formattedValue = fixedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    setAmount(formattedValue);
  };

  const combinedOptions = [
    ...accounts.map((account) => ({
      ...account,
      display: `${account.bank_name} - ${account.sheba_number}`,
    })),
    ...banks.map((bank) => ({
      ...bank,
      display: `${bank.bank_name} - ${bank.sheba_number}`,
    })),
  ];

  useEffect(() => {
    setSelectedOption(combinedOptions?.[0]);
  }, [combinedOptions?.length > 0]);
  if (financialReducer?.loading) {
    return (
      <Card
        style={{
          background: "linear-gradient(to right, #c3ffe9, #fcfff6)",
          padding: "20px",
          borderRadius: "10px",
          gap: 24,
        }}
      >
        <CardContent>
          <CircularProgress />
        </CardContent>
      </Card>
    );
  }
  const separatorNumberWithComma = (number) => {
    if (typeof number !== "number") return "-";
    return number.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return (
    <>
      <Card
        style={{
          background: "linear-gradient(to right, #c3ffe9, #fcfff6)",
          padding: "4px",
          borderRadius: "10px",
          gap: 24,
          height: "100%",
        }}
      >
        <CardContent style={{ height: "100%" }}>
          <Typography
            variant="h6"
            component="div"
            style={{
              marginBottom: "40px",
              textAlign: "center",
              fontWeight: "bold",
              marginBlockEnd: 24,
            }}
          >
            درخواست برداشت آنی
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 12,
              marginBlock: 16,
            }}
          >
            <Typography
              style={{ display: "flex", gap: 4, flexWrap: "wrap" }}
              variant="body2"
              color="text.secondary"
            >
              حداقل برداشت:{" "}
              <Typography style={{ fontWeight: "bold" }}>100,000 </Typography>{" "}
              ریال
            </Typography>
          </div>

          <Select
            value={
              selectedOption
                ? selectedOption.bank_id || selectedOption.accountNumber
                : ""
            }
            onChange={(e) => {
              const selectedValue = combinedOptions.find(
                (option) =>
                  option.bank_id === e.target.value ||
                  option.accountNumber === e.target.value,
              );
              setSelectedOption(selectedValue || null);
            }}
            displayEmpty
            style={{ marginBlock: 24, width: "100%" }}
          >
            <MenuItem value="" disabled>
              انتخاب حساب یا بانک
            </MenuItem>
            {combinedOptions?.map((option) => {
              return (
                <MenuItem
                  key={option.bank_id || option.accountNumber}
                  value={option.bank_id || option.accountNumber}
                >
                  {option.display}
                </MenuItem>
              );
            })}
          </Select>

          <div style={{ marginBlock: 24, width: "100%" }}>
            <TextField
              label="مبلغ"
              value={amount}
              onChange={(e) => formatSeperatorValue(e.target.value)}
              fullWidth
              helperText={`مبلغ وارد شده: ${amount} ریال`}
            />
            <Typography
              style={{
                display: "flex",
                gap: 4,
                flexWrap: "wrap",
              }}
              variant="body2"
              color="text.secondary"
              onClick={() => formatSeperatorValue(String(balance))}
            >
              حداکثر مبلغ قابل برداشت:{" "}
              {balanceData?.loading ? (
                <CircularProgress size={14} />
              ) : (
                <Typography
                  style={{
                    color: balance > 0 ? "#21abff" : "",
                    cursor: "pointer",
                    fontSize: 17,
                  }}
                >
                  {separatorNumberWithComma(balance)}
                </Typography>
              )}{" "}
              ریال
            </Typography>
            {selectedOption?.bank_name?.includes("آینده") && (
              <Alert
                severity="error"
                icon={<Info fontSize="inherit" />}
                sx={{
                  mt: 1,
                  border: "1px solid rgb(186, 0, 13)",
                  borderRadius: 2,
                  backgroundColor: "rgba(255, 0 ,0 ,0.11)",
                }}
              >
                <Typography variant="caption" fontWeight="bold">
                  به دلیل ادغام بانک آینده با بانک ملی، تراکنش‌های این بانک
                  امکان‌پذیر نیست. لطفاً از سایر کارت‌های بانکی استفاده فرمایید.
                </Typography>
              </Alert>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Switch
              size="medium"
              color="primary"
              checked={isCheckedRules}
              onChange={() => setIsCheckedRules(!isCheckedRules)}
            />
            <p
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: 13,
              }}
            >
              پذیرش
              <span
                onClick={() => setOpenModal(true)}
                style={{
                  fontWeight: "bold",
                  color: "#0087fff2",
                  cursor: "pointer",
                }}
              >
                {" "}
                قوانین و مقررات{" "}
              </span>
              مربوط به برداشت آنی
            </p>
          </div>
          <Button
            onClick={() => {
              if (!isCheckedRules || !selectedOption?.bank_id || !amount)
                return;
              withdraw();
            }}
            variant="contained"
            color="primary"
            style={{ display: "flex", width: "100%", marginBlock: 24 }}
            disabled={
              !isCheckedRules ||
              !selectedOption?.bank_id ||
              !amount ||
              Number(removeSeparator(amount)) < 100000 ||
              loading
            }
          >
            برداشت {loading && <CircularProgress size={14} />}
          </Button>
          {/*<Button*/}
          {/*  onClick={handleRedirect}*/}
          {/*  fullWidth*/}
          {/*  variant="outlined"*/}
          {/*  color="primary"*/}
          {/*  startIcon={<GoLinkExternal />}*/}
          {/*>*/}
          {/*  افزودن حساب بانکی*/}
          {/*</Button>*/}
        </CardContent>
      </Card>

      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div
          className={`${classes.modal_alert} lg:w-[60%] md:w-[90%] sm:w-[100%] w-[80%]`}
        >
          <div
            style={{ overflow: "auto" }}
            className="w-full  h-full overflow-auto max-h-[80%]"
          >
            <div className="p-6 gap-4">
              <p style={{ fontWeight: "bold" }} className="gap-4 leading-8">
                مشتری گرامی
              </p>
              <div className="mt-2 flex w-full ">
                <ul>
                  <li>
                    <span>۱-</span> در صورت انتخاب حساب بانک پاسارگاد، در لحظه
                    مبلغ درخواستی به حساب بانکی شما واریز می شود. ( به زودی سایر
                    بانک ها نیز اضافه خواهند شد )
                  </li>
                  <li style={{ lineHeight: 2 }}>
                    <span> ۲ -</span> در صورت انتخاب غیر از بانک پاسارگاد، مبلغ
                    درخواستی شما در سیکل پایای بانک مرکزی به حساب شما واریز
                    خواهد شد.
                  </li>
                  <li style={{ lineHeight: 2 }}>
                    <span> ۳ -</span> سقف برداشت روزانه 50 میلیون تومان می باشد.
                  </li>
                  <li style={{ lineHeight: 2 }}>
                    <span> ۴ -</span> در هر روز فقط یک بار امکان درخواست برداشت
                    وجود دارد.
                  </li>
                  <li style={{ lineHeight: 2 }}>
                    <span> ۵ -</span> مبلغ قابل برداشت شما برای برداشت آنی با
                    مبلغ قابل برداشت عادی متفاوت است.
                  </li>
                  <li style={{ lineHeight: 2 }}>
                    <span> ۶ -</span> در روزهای کاری در بازه زمانی 15:00 الی
                    18:00 امکان درخواست برداشت آنی وجود ندارد.
                  </li>
                  <li style={{ lineHeight: 2 }}>
                    <span> ۷ -</span> مشتریان اعتباری امکان ثبت درخواست برداشت
                    آنی را ندارند.
                  </li>
                </ul>
              </div>
              <p
                style={{
                  color: "red",
                  textAlign: "center",
                  fontSize: 14,
                  marginBlockStart: 8,
                  fontWeight: "bold",
                }}
              >
                {bankMessage}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBlockEnd: 8,
              }}
            >
              <Button
                variant="contained"
                color="inherit"
                size="large"
                className="text-white md:max-w-[250px]  mt-8"
                onClick={() => {
                  setOpenModal(false);
                }}
              >
                بستن{" "}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WithdrawalCard;
